import { NineSliceSprite, Texture } from 'pixi.js';
import type { TileStackView } from './TileStackView';
import type { Tween } from '../../../../libs/TweenManager/Tween';

export class TileStackViewHighlight {
  private highlightStack: NineSliceSprite | null = null;

  private destroy = false;

  private highlightTween: Tween | null = null;

  constructor(private readonly stackView: TileStackView) {}

  public add(): void {
    if (this.highlightStack) return;

    this.destroy = false;

    const assetHeight = 166;

    const zOffset = this.stackView.getVisibleZOffset();

    const highlight = new NineSliceSprite({
      width: 200,
      height: 172,
      topHeight: 85,
      bottomHeight: 85,
      texture: Texture.from('tile_glow'),
    }).props({
      blendMode: 'add',
      parent: this.stackView,
      x: -99,
      y: -80 + zOffset,
      height: assetHeight - zOffset,
      alpha: 0,
    });

    this.highlightTween = highlight.tweenTo({ alpha: 0.8 }, 500, 'sinInOut', true, 0, -1, true);

    this.highlightTween.onLoop.add(() => {
      if (!this.destroy) return;
      highlight.destroy();
      this.highlightStack = null;
      this.highlightTween = null;
    });

    this.highlightStack = highlight;
  }

  public remove(): void {
    if (this.highlightTween) {
      this.highlightTween.timeScale = 10;
    }
    this.destroy = true;
  }
}
